<sn-place-autocomplete-control
  [id]="id"
  [formControl]="formControl"
  [formlyAttributes]="field"
  [options]="to.placesAutocompleteOptions"
  [tabindex]="to.tabindex || 0"
  [placeholder]="to.placeholder"
  (placeChange)="onPlaceChange($event)"
  [autocomplete]="to.autocompleteOn"
>
</sn-place-autocomplete-control>
